import styled from 'styled-components';

export const SameContentModalText = styled.div`
  white-space: pre;
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: 600;
`;
